/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_ResultsInputs */

const es_chat_tool_detail_results = /** @type {(inputs: Chat_Tool_Detail_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultados`)
};

const en_chat_tool_detail_results = /** @type {(inputs: Chat_Tool_Detail_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} results`)
};

/**
* | output |
* | --- |
* | "{count} results" |
*
* @param {Chat_Tool_Detail_ResultsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_results = /** @type {((inputs: Chat_Tool_Detail_ResultsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_ResultsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_results(inputs)
	return en_chat_tool_detail_results(inputs)
});
export { chat_tool_detail_results as "chat.tool_detail.results" }